<script>
import MapGoogle from "@/components/map/MapGoogle";
export default {
  name: "BodyContact",
  components: {
    MapGoogle
  },
  computed: {
    mapConfig() {
      return {
        center: {
          lat: 43.656138,
          lng: 6.688986
        },
        disableDefaultUI: true,
        zoom: 18
      };
    }
  }
};
</script>

<style lang="stylus" scoped>
@import "BodyContact"
</style>
